import { render, staticRenderFns } from "./depthChart.vue?vue&type=template&id=132a8ff3&scoped=true"
import script from "./depthChart.vue?vue&type=script&lang=js"
export * from "./depthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a8ff3",
  null
  
)

export default component.exports